/* VitalUrge: contador de oferta, carruseles, contadores animados, desplegables y línea de tiempo. Sin dependencias. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Contador de oferta: cuenta hasta la medianoche de la zona horaria indicada (por defecto Ciudad de México)
  // y se reinicia cada 24 horas a las 00:00 de esa zona. Es igual para todos los visitantes.
  const timers = document.querySelectorAll('[data-vu-timer]');
  if (timers.length) {
    const formatters = new Map();
    const secondsIntoDay = (tz) => {
      try {
        if (!formatters.has(tz)) {
          formatters.set(tz, new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }));
        }
        const parts = formatters.get(tz).formatToParts(new Date());
        const get = (type) => parseInt(parts.find((p) => p.type === type).value, 10);
        return get('hour') * 3600 + get('minute') * 60 + get('second');
      } catch (e) {
        const d = new Date();
        return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
      }
    };
    const els = [...timers].map((t) => ({ tz: t.dataset.tz || 'America/Mexico_City', h: t.querySelector('[data-vu-h]'), m: t.querySelector('[data-vu-m]'), s: t.querySelector('[data-vu-s]') }));
    const tick = () => {
      els.forEach((t) => {
        const left = 86400 - secondsIntoDay(t.tz);
        t.h.textContent = pad(Math.floor(left / 3600));
        t.m.textContent = pad(Math.floor((left % 3600) / 60));
        t.s.textContent = pad(left % 60);
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  // Galería del producto: las fotos 2+ no se dibujan (ni descargan) hasta que la página ha cargado o el cliente toca la galería.
  const gallery = document.querySelector('.vu-pdp .product__media-list');
  if (gallery) {
    const ready = () => gallery.classList.add('vu-gal-ready');
    const wrap = gallery.closest('slider-component') || gallery;
    ['pointerdown', 'touchstart', 'focusin'].forEach((e) => wrap.addEventListener(e, ready, { once: true, passive: true }));
    const afterLoad = () => ('requestIdleCallback' in window ? requestIdleCallback(ready, { timeout: 2000 }) : setTimeout(ready, 500));
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });

    // Miniaturas (escritorio): al pulsar una, la galería se desliza a esa foto y la miniatura queda marcada.
    const thumbs = [...document.querySelectorAll('.vu-pdp .thumbnail-list .thumbnail')];
    const slides = [...gallery.querySelectorAll(':scope > .product__media-item')];
    const mark = (i) => thumbs.forEach((t, k) => (k === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
    // Se escucha en la lista en fase de captura para adelantarse al código de Dawn (que reordena las fotos).
    const thumbList = document.querySelector('.vu-pdp .thumbnail-list');
    if (thumbList) thumbList.addEventListener('click', (e) => {
      const t = e.target.closest('.thumbnail');
      const i = thumbs.indexOf(t);
      if (i < 0) return;
      e.preventDefault();
      e.stopPropagation();
      ready();
      const slide = slides[i];
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      mark(i);
    }, true);
    if (thumbs.length) {
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        mark(Math.min(i, thumbs.length - 1));
      }, { passive: true });
    }
  }

  // Botones con data-vu-atc (p. ej. "Agregar al carrito" de la garantía): pulsan el botón de compra principal, así Kaching
  // añade la oferta que esté seleccionada en ese momento. Si no existe el botón principal, el enlace baja a las ofertas.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-vu-atc]');
    if (!a) return;
    const buy = document.querySelector('#vu-buy .product-form__submit');
    if (!buy || buy.disabled) return;
    e.preventDefault();
    buy.click();
  });

  // El resto se prepara cuando el navegador queda libre, para no competir con la carga de la página.
  const init = () => {
    // Carruseles: puntos sincronizados con el desplazamiento y flecha "siguiente".
    document.querySelectorAll('[data-vu-carousel]').forEach((c) => {
      const track = c.querySelector('.vu-track');
      const dotsWrap = c.querySelector('[data-vu-dots]');
      const slides = [...track.children];
      if (!dotsWrap || slides.length < 2) return;
      const dots = slides.map((slide, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Ir a ${i + 1}`);
        b.addEventListener('click', () => track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }));
        dotsWrap.appendChild(b);
        return b;
      });
      const current = () => Math.round(track.scrollLeft / Math.max(1, slides[0].offsetWidth + 16));
      let last = -1;
      const sync = () => {
        const i = current();
        if (i === last) return;
        last = i;
        dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      };
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      sync();
      const next = c.querySelector('[data-vu-next]');
      if (next) next.addEventListener('click', () => {
        const i = (current() + 1) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    // Números que "cuentan" al entrar en pantalla (una sola vez) y barras que se rellenan.
    const animate = (el) => {
      if (el.dataset.vuFill !== undefined) {
        el.style.width = `${el.dataset.vuFill}%`;
        return;
      }
      const target = parseFloat(el.dataset.vuCount);
      if (reduce || isNaN(target)) return;
      const dur = 1600;
      const t0 = performance.now();
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      };
      el.textContent = '0';
      requestAnimationFrame(step);
    };
    const counters = document.querySelectorAll('[data-vu-count], [data-vu-fill]');
    if (counters.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          animate(e.target);
        });
      }, { threshold: 0.4 });
      counters.forEach((el) => io.observe(el));
    } else {
      counters.forEach((el) => el.dataset.vuFill !== undefined && (el.style.width = `${el.dataset.vuFill}%`));
    }

    // Desplegables con apertura y cierre suaves (acordeones del bloque de compra y FAQ).
    document.querySelectorAll('.vu-pdp .product__accordion details, .vu-faq details').forEach((d) => {
      const summary = d.querySelector('summary');
      const body = summary && summary.nextElementSibling;
      if (!body) return;
      body.setAttribute('data-vu-acc', '');
      let anim;
      summary.addEventListener('click', (e) => {
        if (reduce) return;
        e.preventDefault();
        if (anim) anim.cancel();
        if (d.open) {
          anim = body.animate([{ height: `${body.offsetHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' });
          d.classList.add('is-closing');
          anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); anim = null; };
        } else {
          d.open = true;
          anim = body.animate([{ height: '0px', opacity: 0 }, { height: `${body.offsetHeight}px`, opacity: 1 }], { duration: 360, easing: 'cubic-bezier(.4,0,.2,1)' });
          anim.onfinish = () => { anim = null; };
        }
      });
    });

    // Línea de tiempo: la barra avanza al bajar y retrocede al subir; solo escucha el scroll mientras está cerca de la pantalla.
    document.querySelectorAll('[data-vu-timeline]').forEach((list) => {
      const fill = list.querySelector('[data-vu-timeline-fill]');
      const items = [...list.querySelectorAll('li')];
      let ticking = false;
      const update = () => {
        ticking = false;
        const r = list.getBoundingClientRect();
        const mark = window.innerHeight * 0.6;
        const p = Math.min(1, Math.max(0, (mark - r.top) / r.height));
        fill.style.height = `${p * (r.height - 12)}px`;
        items.forEach((li) => li.classList.toggle('is-on', li.getBoundingClientRect().top + 15 < mark));
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => {
          if (e.isIntersecting) { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
          else window.removeEventListener('scroll', onScroll);
        }, { rootMargin: '200px 0px' }).observe(list);
      } else {
        window.addEventListener('scroll', onScroll, { passive: true });
        update();
      }
    });
  };

  if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 1500 });
  else setTimeout(init, 200);
})();
